interface VolatilityCheck {
  isVolatile: boolean;
  message: string;
  allowedPriceRange: {
    min: number;
    max: number;
  };
}

export const CIRCUIT_BREAKER_THRESHOLD = 0.15; // 15% price movement
export const COOLING_PERIOD_MS = 300000; // 5 minutes

export const checkVolatility = (
  currentPrice: number,
  targetPrice: number,
  lastTradeTimestamp?: number
): VolatilityCheck => {
  const priceChange = Math.abs(targetPrice - currentPrice) / currentPrice;
  const now = Date.now();
  const isInCoolingPeriod = lastTradeTimestamp && (now - lastTradeTimestamp) < COOLING_PERIOD_MS;
  
  // Calculate allowed price range
  const maxChange = CIRCUIT_BREAKER_THRESHOLD;
  const allowedPriceRange = {
    min: currentPrice * (1 - maxChange),
    max: currentPrice * (1 + maxChange)
  };

  if (priceChange > CIRCUIT_BREAKER_THRESHOLD) {
    return {
      isVolatile: true,
      message: `Circuit breaker triggered: Price movement exceeds ${CIRCUIT_BREAKER_THRESHOLD * 100}% threshold`,
      allowedPriceRange
    };
  }

  if (isInCoolingPeriod) {
    const remainingCooldown = Math.ceil((COOLING_PERIOD_MS - (now - (lastTradeTimestamp || 0))) / 1000);
    return {
      isVolatile: true,
      message: `Cooling period active. Please wait ${remainingCooldown} seconds before next trade`,
      allowedPriceRange
    };
  }

  return {
    isVolatile: false,
    message: "",
    allowedPriceRange
  };
};